<div
  class="query-title-bar"
  [class.has-reports]="
    routing.isChart() && (routing.isQuery() || routing.isSearch())
  "
>
  <div class="query-title-left">
    <div class="name-section">
      <span class="label">{{ label }}</span>
      <div class="name-row" [class.has-dropdown]="collectionQueries.length > 0">
        <span
          class="name"
          *ngIf="routing.isQuery()"
          matTooltipShowDelay="500"
          (click)="openQueryMenu()"
          >{{ name }}</span
        >
        <span
          class="name"
          *ngIf="!routing.isQuery()"
          [matTooltip]="name | nicetxt: false"
          matTooltipShowDelay="500"
          (click)="openQueryMenu()"
          >{{ name | nicetxt: false }}</span
        >
        <button
          *ngIf="collectionQueries.length > 0"
          #queryMenuTrigger="matMenuTrigger"
          class="query-switch-btn"
          mat-icon-button
          [matMenuTriggerFor]="queryPickerMenu"
          matTooltipShowDelay="500"
        >
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #queryPickerMenu="matMenu">
          <button
            mat-menu-item
            [style.background]="
              params.id === params.groupId ? 'rgb(50 50 50 / 85%)' : null
            "
            [style.font-weight]="params.id === params.groupId ? '600' : null"
            [style.height]="'auto'"
            [style.max-width]="'350px'"
            (click)="navigateToCollection()"
          >
            Overall
          </button>
          <button
            *ngFor="let q of collectionQueries"
            mat-menu-item
            [style.background]="
              q.uid === params.id ? 'rgb(50 50 50 / 85%)' : null
            "
            [style.font-weight]="q.uid === params.id ? '600' : null"
            [style.height]="'auto'"
            [style.max-width]="'350px'"
            (click)="navigateToQuery(q)"
          >
            {{ q.name }}
          </button>
        </mat-menu>
      </div>
    </div>

    <div class="divider"></div>

    <div class="sentiment-section" *ngIf="titolo?.sentiment">
      <span class="label">Sentiment</span>
      <div class="score-row">
        <span
          class="score"
          [style.color]="titolo.sentiment.sentiment | color"
          >{{ titolo.sentiment.sentiment | percent }}</span
        >
        <span
          class="delta-pill"
          [class.negative]="sentimentDelta < 0"
          [class.positive]="sentimentDelta > 0"
        >
          {{ sentimentDelta | round | trend
          }}{{ sentimentDelta | round | negative }}
        </span>
      </div>
    </div>
  </div>

  <div class="query-title-right">
    <div class="actions-section">
      <div class="actions-row">
        <button
          *ngIf="
            auth.featureFlags.editQueries &&
            (!routing.isQuery() || params.id !== params.groupId)
          "
          mat-stroked-button
          (click)="onEdit()"
        >
          <mat-icon>edit</mat-icon>
          <span>{{
            isNarrow ? 'Edit' : routing.isQuery() ? 'Edit Query' : 'Edit search'
          }}</span>
        </button>

        <button
          mat-stroked-button
          *ngIf="routing.isSearch() && auth.featureFlags.addQueries"
          [matMenuTriggerFor]="saveMenu"
        >
          <mat-icon>save</mat-icon>
          <span>Save</span>
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #saveMenu="matMenu">
          <button mat-menu-item (click)="onSave('add')">
            Add to existing collection
          </button>
          <button mat-menu-item (click)="onSave('create')">
            Add to new collection
          </button>
        </mat-menu>

        <div
          class="divider"
          *ngIf="
            auth.featureFlags.editQueries &&
            (!routing.isQuery() || params.id !== params.groupId)
          "
        ></div>

        <app-report-box
          *ngIf="
            titolo &&
            routing.isChart() &&
            !config.appConfig.setup.reportsDisabled
          "
          mode="query"
          [buttonLabel]="isNarrow ? 'Report' : 'Due Diligence Report'"
        ></app-report-box>
      </div>
    </div>
  </div>
</div>
